import { render, staticRenderFns } from "./UnloadNew.vue?vue&type=template&id=20e1eb20&scoped=true"
import script from "./UnloadNew.vue?vue&type=script&lang=js"
export * from "./UnloadNew.vue?vue&type=script&lang=js"
import style0 from "./UnloadNew.vue?vue&type=style&index=0&id=20e1eb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1eb20",
  null
  
)

export default component.exports